import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header";
import {
  bannerCircle,
  Sec3Img1,
  Sec4Slider1,
  Sec4Slider2,
  Sec4Slider3,
  section1Img1,
} from "../Constants/Images";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlass,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";

import Footer from "../Components/Footer";

import AddressInput from "../Components/AddressInput";
import ChatModal from "../Components/Modals/ChatModal";
import { useNavigate } from "react-router";
import AutoCompleteListInput from "../Components/AutoCompleteListInput";
import { occassionTypes, spaceTypes, vibesTypes } from "../Constants";
import { API } from "../utils/Apis";

const Home = () => {
  const sec4Slides = [Sec4Slider1, Sec4Slider2, Sec4Slider3];

  const navigate = useNavigate();
  const sec4SliderRef = useRef<any>(undefined);
  const [searchForm, setSearchForm] = useState({
    activity: "",
    address: "",
    vibe: "",
    location: { lat: "", lng: "" },
  });

  const [sec4SliderCurrent, setSec4SliderCurrent] = useState(1);
  const [showChatModal, setShowChatModal] = useState(false);
  const [tagsLoading, setTagsLoading] = useState(false);
  const [occassionTypeTags, setOccassionTypeTags] = useState([]);

  const [mounted, setMounted] = useState(false);

  const getSpaceTypes = () => {
    if (!tagsLoading) {
      setTagsLoading(true);
      API.getSpaceTypes({ type: "occassion" })
        .then((res) => {
          if (res.type === "success") {
            const tempTags = res.data;

            const uniqueSortedTexts = [
              ...new Set(tempTags.map((item) => item.text)),
            ].sort((a, b) => a.localeCompare(b));

            setOccassionTypeTags(uniqueSortedTexts);

            console.log("tempTags :", tempTags);
          } else {
            setOccassionTypeTags(occassionTypes);
          }
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => setTagsLoading(false));
    }
  };

  useEffect(() => {
    getSpaceTypes();
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="landing-page">
      {/* Header */}
      <Header />

      {/* Home Banner */}
      <div className="home-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-6">&nbsp;</div>
            <div className="col-md-6">
              <div className="banner-text">
                <img src={bannerCircle} alt="" />

                <h3>
                  Find a <span>Space.</span>
                </h3>
                <h3>Fulfill your vision.</h3>
              </div>
            </div>
          </div>

          <div className="searchbox-contianer">
            {/* <Button onClick={() => setShowChatModal(true)}>
              <FontAwesomeIcon
                icon={faMicrophone}
                color="#ffffff"
                size={"1x"}
              />{" "}
              Let's Start Conversation
            </Button>
            <span>Or search below</span> */}

            <div className="row">
              <div className="col-md-9 col-sm-7 col-xs-12">
                <div className="search-input-wrapper">
                  <form method="post" onSubmit={() => {}}>
                    <div className="form-group">
                      <label htmlFor="search-activity" className="form-label">
                        What are you planning?
                      </label>

                      <AutoCompleteListInput
                        fieldName="activity"
                        value={searchForm.activity}
                        items={occassionTypes}
                        placeHolder="Enter your activity"
                        setSelectedItem={(text: string) =>
                          setSearchForm({ ...searchForm, activity: text })
                        }
                      />

                      {/* <input
                        id="search-activity"
                        name="activity"
                        type="text"
                        className="form-control"
                        placeholder="Enter your activity"
                        value={searchForm.activity}
                        onChange={(e) => onSearchChange(e)}
                      /> */}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Vibe</label>

                      <AutoCompleteListInput
                        fieldName="vibe"
                        value={searchForm.vibe}
                        items={vibesTypes}
                        placeHolder="Enter your vibe"
                        setSelectedItem={(text: string) =>
                          setSearchForm({ ...searchForm, vibe: text })
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Where?</label>

                      <div className="position-relative">
                        <AddressInput
                          placeHolder="Search with location"
                          address={searchForm.address}
                          onChange={(address: string) => {
                            setSearchForm({
                              ...searchForm,
                              address: address,
                            });
                          }}
                        />
                      </div>
                    </div>

                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        navigate("/search", {
                          state: searchForm,
                        })
                      }
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} color="#fff" />{" "}
                      Search
                    </Button>
                  </form>
                </div>
              </div>

              <div className="col-md-3 col-sm-5 col-xs-12">
                <div className="studio-container">
                  <h3>
                    Production <span>Superb Studio</span>
                  </h3>
                  <p>Houston TX, US</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Home Section 1 */}
      <div className="section-1-wrapper">
        <div className="container">
          <div className="section-2-content">
            <h3>A space for every moment</h3>
            <p>Book a unique space for your activity</p>
          </div>

          <div className="section-1-img-w">
            <div className="row">
              <div className="col-md-3">
                <div className="section-1-imgs img-1">
                  <img src={section1Img1} alt="" />
                </div>
              </div>

              <div className="col-md-6 text-center">
                <div className="tags-cloud-wrapper">
                  {tagsLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                  {!tagsLoading &&
                    occassionTypeTags &&
                    occassionTypeTags.map((item, index) => (
                      <span
                        className="as-link"
                        key={`${item}-${index}`}
                        onClick={(e) => {
                          e.preventDefault();

                          navigate("/search", {
                            state: { activity: item },
                          });
                        }}
                      >
                        {item}
                      </span>
                    ))}
                </div>
                {/* <Button>Browse All Activities</Button> */}
              </div>
              <div className="col-md-3">
                <div className="section-1-imgs img-2">
                  <img src={section1Img1} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Home Section 2 */}
      <div className="section-2-wrapper">
        <div className="container">
          <div className="section-2-content">
            <h3>Wherever you Dream</h3>
            <p>Explore different space types near you</p>
            <p>#GetSpacii</p>
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              navigation={true}
              slidesPerView={window.outerWidth < 768 ? 2 : 3}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              pagination={false}
              modules={[EffectCoverflow, Pagination, Navigation]}
              className="mySwiper"
            >
              {spaceTypes &&
                spaceTypes.map((item, index) => (
                  <SwiperSlide key={`${item}-${index}`}>
                    <div
                      className="slider-img-wrapper as-link"
                      onClick={() => {
                        navigate("/search", {
                          state: { spaceType: item },
                        });
                      }}
                    >
                      <img src={Sec4Slider1} alt="" />
                      <h2>{item}</h2>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>

            <Button
              onClick={() => {
                navigate("/search");
              }}
            >
              Discover The Possibilities
            </Button>
          </div>

          {/* <HomeImageGallery /> */}
        </div>
      </div>

      {/* Home Section 3 */}
      <div className="section-3-wrapper">
        <div className="big-text">Spacii</div>
        <div className="container">
          <div className="row">
            <div className="col-md-5 col-sm-6">
              <div className="section-3-content">
                <h3>Plan Something Unforgettable</h3>

                <ul>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();

                        navigate("/search", {
                          state: { address: "Washington" },
                        });
                      }}
                    >
                      Washington DC
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        navigate("/search", {
                          state: { address: "Maryland" },
                        });

                        e.preventDefault();
                      }}
                    >
                      Maryland
                    </a>
                  </li>
                  <li className="active">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();

                        navigate("/search", {
                          state: { address: "Virginia" },
                        });
                      }}
                    >
                      Virginia <FontAwesomeIcon icon={faChevronRight} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-7 col-sm-6">
              <div className="section-3-imgs">
                <img src={Sec3Img1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Home Section 4  */}
      <div className="section-4-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="section-4-content">
                {sec4SliderCurrent === 1 && (
                  <>
                    <h3>New and never-ending possibilities</h3>
                    <p>
                      Find everything from professionally equipped studios to
                      unconventional rooms and residences.
                    </p>
                  </>
                )}
                {sec4SliderCurrent === 2 && (
                  <>
                    <h3>New and never-ending possibilities..</h3>
                    <p>
                      Find everything from professionally equipped studios to
                      unconventional rooms and residences.
                    </p>
                  </>
                )}
                {sec4SliderCurrent === 3 && (
                  <>
                    <h3>New and never-ending possibilities...</h3>
                    <p>
                      Find everything from professionally equipped studios to
                      unconventional rooms and residences.
                    </p>
                  </>
                )}

                <div className="slider-nav">
                  {sec4SliderCurrent && sec4SliderCurrent !== null && (
                    <span>
                      {sec4SliderCurrent}/{sec4Slides.length}
                    </span>
                  )}
                  <div className="slider-nav-arrows">
                    <span
                      className="prv"
                      onClick={() => {
                        if (sec4SliderRef) {
                          sec4SliderRef?.current?.slidePrev();
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </span>

                    <span
                      className="next"
                      onClick={() => {
                        if (sec4SliderRef) {
                          sec4SliderRef?.current?.slideNext();
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faChevronRight} />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="section-4-slider">
                <Swiper
                  ref={sec4SliderRef}
                  onSlideChange={(swiper) =>
                    setSec4SliderCurrent(swiper.activeIndex + 1)
                  }
                  onInit={(swiper) => {
                    sec4SliderRef.current = swiper;
                    setSec4SliderCurrent(swiper.activeIndex + 1);
                  }}
                  slidesPerView={1}
                  autoplay={{
                    delay: 3000,
                  }}
                >
                  <SwiperSlide>
                    <img src={Sec4Slider1} alt="" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={Sec4Slider2} alt="" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={Sec4Slider3} alt="" />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />

      {showChatModal && (
        <ChatModal
          show={showChatModal}
          closeModal={() => setShowChatModal(false)}
        />
      )}
    </div>
  );
};

export default Home;
